import { TLC_CONSTANTS } from "../../../../js/lib/tlc-constants";
import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { EventQueue } from "../../../../js/lib/events/EventQueue";
import { TLCLogger } from "../../../../js/lib/logger";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { ApplicationData } from "../ApplicationData";
import { SimpleErrorDialog } from "../controls/simpleErrorDialog";
import { PrintMyData } from "../utils/PrintMyData";
import { AccountHolder } from "@tlc/ls2pac/components/Account";

export const PrintAccountDataEvent = "onClickPrintAccountData"; // LS2PAC_CONSTANTS.Events.onClickPrintAccountData

export const PrintAccountDataManager = (function($) {

    var printDialog = undefined,
        accountSummary = null,
        accountData = null;

    TLCEventManager.addListener(PrintAccountDataEvent, function(event) {
        if(!event || !event.sections || event.sections.length == 0) {
            updateUI(event.domElement);
            SimpleErrorDialog.show(ApplicationData.language.noExportSelectedMessage);
        } else {
            fetchDataToPrint(event);
        }
    });

    var updateUI = function(link) {
        if(link) {
            link.removeClass(TLC_CONSTANTS.CssClasses.disabled);
            link.parent().spin(false);
        }
    };

    var fetchDataToPrint = function(event) {
        var listOfEvents = [],
            dataToPrint = {};

        $.each(event.sections, function(index, section) {
           switch(section) {

               case LS2PAC_CONSTANTS.MyAccountPrintTypes.accountSummary:
                   dataToPrint.accountSummary = accountData;
                   break;

               case LS2PAC_CONSTANTS.MyAccountPrintTypes.loans:
                   TLCLogger.log("loans");
                   listOfEvents.push({
                       eventToFire: LS2PAC_CONSTANTS.Events.onGetAllCurrentLoans,
                       payload:	{total: accountSummary.loanCount},
                       callback:	function(event) {
                           dataToPrint.loans = event.data;
                       }
                   });
                   break;

               case LS2PAC_CONSTANTS.MyAccountPrintTypes.holds:
                   var requestsCount = accountSummary.arrivedHolds + accountSummary.pendingHolds;
                   TLCLogger.log(requestsCount + " requests");
                   listOfEvents.push({
                       eventToFire: LS2PAC_CONSTANTS.Events.onGetAllHolds,
                       payload:	{total: requestsCount},
                       callback:	function(event) {
                           dataToPrint.requests = event.data;
                       }
                   });
                   break;

               case LS2PAC_CONSTANTS.MyAccountPrintTypes.bookings:
                   TLCLogger.log("bookings ", LS2PAC_CONSTANTS.Events.onGetAllBookings);
                   listOfEvents.push({
                       eventToFire: LS2PAC_CONSTANTS.Events.onGetAllBookings,
                       callback:	function(event) {
                           dataToPrint.bookings = event.data || [];
                       }
                   });
                   break;

               case LS2PAC_CONSTANTS.MyAccountPrintTypes.fines:
                   TLCLogger.log("fines");
                   listOfEvents.push({
                       eventToFire: LS2PAC_CONSTANTS.Events.onGetAllFines,
                       callback:	function(event) {
                           dataToPrint.fines = event.data;
                       }
                   });
                   break;

               case LS2PAC_CONSTANTS.MyAccountPrintTypes.loanHistory:
                   TLCLogger.log("loanHistory");
                   listOfEvents.push({
                       eventToFire: LS2PAC_CONSTANTS.Events.onGetAllLoanHistoryRange,
                       payload: {
                           startDate: event.startDate,//format(ApplicationData.language.dateFormat),
                           endDate:   event.endDate//format(ApplicationData.language.dateFormat)
                       },
                       callback:	function(loanHistoryEvent) {
                           dataToPrint.loanHistory = loanHistoryEvent.data;
                           dataToPrint.startDate = event.startDate.format(ApplicationData.language.dateFormat);
                           dataToPrint.endDate = event.endDate.format(ApplicationData.language.dateFormat);
                       }
                   });
                   break;
           }
        });

        EventQueue.createQueue(listOfEvents, function() {
            TLCLogger.log("done fetching?", dataToPrint);
            updateUI(event.domElement);
            var printWindow = getPrintDialogInstance();

			printWindow.openPrintDialog(function(){
				printWindow.print(dataToPrint);
			});
        });
    };



    var getPrintDialogInstance = function() {
        if(printDialog === undefined) {
            printDialog = new PrintMyData();
        }
        return printDialog;
    };

    AccountHolder.subscribe((data) => {
        accountData = data;
        accountSummary = data.accountSummary;
    });

    return {};
})(jQuery);